@if (headerInformation$ | async; as headerInformation) {
    @if (headerInformation.isRawFreeLicense && headerInformation.testDaysLeft > 0) {
        <div
            class="inline-flex items-center rounded-md border border-gray-600 bg-gray-700 px-3 py-1.5 text-sm font-medium text-gray-100 transition-colors duration-200 hover:border-gray-500 hover:bg-gray-600 hover:text-white">
            <mat-icon svgIcon="mat_outline:auto_awesome" class="mr-1.5 h-3.5 w-3.5"></mat-icon>
            <span>
                {{ headerInformation.testDaysLeft | number: '1.0-0' }} Tage Testphase verbleibend. <br />
                Danach wechselt deine Organisation automatisch auf eine Free Lizenz.<br />
                <a href="https://www.ailotse.com/preise" target="_blank" rel="noopener noreferrer" class="underline"
                    >Wähle jetzt ein Upgrade-Paket</a
                >.
            </span>
        </div>
    }
}
